
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sustainability",
      function () {
        return require("private-next-pages/sustainability.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sustainability"])
      });
    }
  